import { Injectable } from '@angular/core';
import { Restangular } from 'ngx-restangular';

export interface ProductClickEventRecord {
  id: string;
  userId: string;
  userName?: string | null;
  email?: string | null;
  brandId?: string | null;
  brand?: string | null;
  occurredAt: string;
  rewardTileName: string;
  eventType: string;
  buttonLabel?: string | null;
  actionType?: string | null;
  surface: string;
  sourceType?: string | null;
  sourceId?: string | null;
  route?: string | null;
  metadata?: string | null;
}

export interface ProductClickEventListResponse {
  items: ProductClickEventRecord[];
  total: number;
  page: number;
  limit: number;
}

export interface ProductClickEventListQuery {
  search?: string;
  page: number;
  limit: number;
  sort: string;
  direction: 'asc' | 'desc';
}

@Injectable({providedIn: 'root'})
export class ProductClickEventsService {
  constructor(private restangular: Restangular) {}

  list(query: ProductClickEventListQuery): Promise<ProductClickEventListResponse> {
    const requestQuery = Object.entries(query).reduce((params, [key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params[key] = value;
      }
      return params;
    }, {} as Record<string, string | number>);

    return this.restangular
      .one('admin')
      .one('productClickEvents')
      .customGET('', requestQuery)
      .toPromise();
  }
}
